import { injectable } from 'inversify';
import { ISystemLocationsRepository } from '@/domain/repositories/system-locations/system-locations.repository.interface';
import { Result } from '@/entities';
import { getSystemLocationCourts } from '@/infrastructure/network/data/system-locations';
import { systemLocationCourtsDtoToSystemLocationCourts } from '@/infrastructure/mapper/system-locations-mapper';
import { SystemLocationsCourts } from '@/entities/SystemLocationsCourts';
@injectable()
export class SystemLocationsRepository implements ISystemLocationsRepository {
	async getSystemLocationCourts(moduleFor: string, moduleUuid: string, locationId: string): Promise<Result<SystemLocationsCourts[]>> {
		const response = await getSystemLocationCourts({
			moduleFor,
			moduleUuid,
			locationId
		});

		if (response.statusCode === 200) {
			return {
				data: systemLocationCourtsDtoToSystemLocationCourts(response.data?.[0]?.systemCourts ?? []),
				statusCode: response.statusCode
			};
		} else {
			return {
				statusCode: response.statusCode,
				correlationId: response.correlationId,
				error: response.error
			};
		}
	}
}
